import React from 'react';
import { Paper } from '@mui/material';

function Banner({ image, title, description }) {
  return (
    <Paper
      style={{
        position: 'relative',
        backgroundImage: `url(${image})`,
        backgroundSize: 'cover',
        height: '500px',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 1,
        }}
      ></div>
      <div style={{ position: 'relative', zIndex: 2, textAlign: 'center' }}>
        <h1>{title}</h1>
        {description && <h4>{description}</h4>}
      </div>
    </Paper>
  );
}

export default Banner;
